import { actionHelpers } from 'app-components/flux/core';

export const createDialog = actionHelpers.createAction('CREATE_DIALOG');
export const removeDialog = actionHelpers.createAction('REMOVE_DIALOG');
export const showNextDialog = actionHelpers.createAction('SHOW_NEXT_DIALOG');
export const updateDialogProps = actionHelpers.createAction('UPDATE_DIALOG_PROPS');
